const Loading = () => {
  return (
    <div className="loader">
      <img src="/spinner.gif" id="spinner" alt="spinner" />
    </div>
  );
};

export default Loading;
